import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
    state: {
        value1: '自动检测',
        value2: '中文（简体）',
        value3: '通用领域',
        historyMax: 500,
        guideTarget: '中文简体',
        guideDomain: '通用领域',
        guideQuestion: `As a global technology leader, Lenovo is pioneering the use of groundbreaking AI to enhance our own operations, so we can help enterprises transform and embrace smarter AI for all.`,
        currentConversationId: '',
        translateDBInstance: null, // 翻译数据库实例
        // translateDBInstanceTourist: null, // 游客翻译数据库实例
        options3: ['通用领域', '学术论文', '金融财经', '生物医学'],
        options3Dict: {
            '通用领域': 'General_field',
            '学术论文': 'Academic_paper',
            '金融财经': 'Finance_economics',
            '生物医学': 'Biomedicine',
        },
        options: ['自动检测', '中文（简体）', '中文（繁体）', '英文'],
        optionsDict: {
            '自动检测': 'auto',
            '中文（简体）': 'chinese_jian',
            '中文（繁体）': 'chinese_fan',
            '英文': 'english',
        },
        inputOptions: {}
    },
    mutations: {
        updateValue3(state, payload) {
            state.value3 = payload
        },
        updateValue2(state, payload) {
            state.value2 = payload
        },
        updateValue1(state, payload) {
            state.value1 = payload
        },
        updateCurrentConversationId(state, payload) {
            state.currentConversationId = payload
        },
        updateTranslateDBInstance(state, payload) {
            state.translateDBInstance = payload
        },
        // updateTranslateDBInstanceTourist(state, payload) {
        //     state.translateDBInstanceTourist = payload
        // },
        updateInputOptions(state, payload) {
            state.inputOptions = payload
        },
    },
    actions: {

    },
    getters: {
    },
    namespaced: true
}